var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "modal__backdrop",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.conditionalClose.apply(null, arguments)
          }
        }
      },
      [
        _c("div", { staticClass: "modal__wrapper" }, [
          _c(
            "section",
            {
              staticClass: "modal__container",
              attrs: { role: "dialog", "aria-hidden": !_vm.show },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [_c("div", { attrs: { role: "document" } }, [_vm._t("default")], 2)]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4daf756", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4daf756","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/Modal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a4daf756","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/Modal.vue
// module chunks = 0